const isMacOs = (): boolean =>
  typeof window !== 'undefined' && /(Mac|iPhone|iPad|iPod)/i.test(window.navigator.platform ?? '');

export const getShortcutLabel = (shortcut?: string): string | undefined => {
  if (!shortcut) {
    return undefined;
  }

  const isMac = isMacOs();
  const tokens = shortcut.split('+');

  const mapped = tokens.map((token) => {
    const normalized = token.trim().toLowerCase();

    switch (normalized) {
      case 'mod':
        return isMac ? '⌘' : 'Ctrl';
      case 'shift':
        return isMac ? '⇧' : 'Shift';
      case 'alt':
      case 'option':
        return isMac ? '⌥' : 'Alt';
      default:
        return normalized.length === 1 ? normalized.toUpperCase() : normalized[0].toUpperCase() + normalized.slice(1);
    }
  });

  return isMac ? mapped.join('') : mapped.join('+');
};

export const buildTooltipLabel = (aria: string, shortcut?: string): string => {
  const shortcutLabel = getShortcutLabel(shortcut);

  return shortcutLabel ? `${aria} · ${shortcutLabel}` : aria;
};
